<template>
  <v-select
    v-model="innerModel"
    :disabled="disabled"
    :item-text="itemText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :clearable="clearable"
    dense
    outlined
    hide-details
  />
</template>

<script>
export default {
  name: "SearchSingleSelectBox",
  props: {
    value: undefined,
    items: Array,
    label: {
      type: String,
      default: "Select Items",
    },
    itemValue: {
      type: String,
      default: "codeKey"
    },
    itemText: {
      type: String,
      default: "codeValue"
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      innerModel: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.innerModel = newValue;
      }
    },
    innerModel: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.$emit('input', newValue);
        this.$emit('update:selected', newValue);
      }
    },
  },
  created() {
  },
  methods: {
    checkDirty(newValue, oldValue) {
      if (newValue === undefined && oldValue !== undefined) return true;
      if (newValue === oldValue) return false;
      if (this.items.filter(e => e[this.itemValue] === newValue).length < 1) return false;
      return true;
    },
  },
}
</script>

<style scoped>
>>> input:read-only, >>> input {
  background-color: transparent !important;
  border: 0 !important;
}
</style>
